<template>
  <div v-if="task">
    <box tag="section">
      <header class="d-flex align-items-center">
        <div class="mr-auto">
          <h1 class="mb-3">Bitcointalk</h1>
          <dates-range :start="task.start" :end="task.end" />
          <div v-if="task.join" class="small text-lighten">
            Joined 10.11.2018
          </div>
        </div>
        <div>
          <b-row class="cols align-items-center">
            <b-col>
              <div>{{ $t('participantsList') }}:</div>
              <router-link
                :to="{
                  name: 'campaign-task-statistics',
                  params: {
                    id: $route.params.id,
                    name: $route.params.name
                  }
                }"
                class="d-block participants-link text-5-alt"
              >
                <participants :participants="task.participants" />
              </router-link>
              <div v-if="task.join" class="small text-lighten text-nowrap">
                Next check <strong>10.11.2018 17:14</strong>
              </div>
            </b-col>
            <b-col>
              <button-join
                :join="task.join"
                @join="tryJoin"
                @leave="tryLeave"
              />
            </b-col>
          </b-row>
        </div>
      </header>
      <hr class="mt-5 mb-5" />
      <task-progress v-if="task.join" />
      <template v-else>
        <section v-html="task.text"></section>
        <h2 class="mb-4">Signatures</h2>
        <div>
          <legend class="col-form-label pt-0">Jr. member:</legend>
          <pre>adsfsdgf</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Member:</legend>
          <pre>adsfsdgf</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Full member:</legend>
          <pre>adsfsdgf</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Sr. member:</legend>
          <pre>adsfsdgf</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Hero member:</legend>
          <pre>adsfsdgf</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Legendary member:</legend>
          <pre>adsfsdgf</pre>
        </div>
      </template>
    </box>
    <box v-if="task.join">
      <div>
        <section v-html="task.text"></section>
        <h2>Signatures</h2>
        <div>
          <legend class="col-form-label pt-0">Jr. member:</legend>
          <pre>{{ task.signatures.jrMember }}</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Member:</legend>
          <pre>{{ task.signatures.member }}</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Full member:</legend>
          <pre>{{ task.signatures.fullMember }}</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Sr. member:</legend>
          <pre>{{ task.signatures.srMember }}</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Hero member:</legend>
          <pre>{{ task.signatures.heroMember }}</pre>
        </div>
        <div>
          <legend class="col-form-label pt-0">Legendary member:</legend>
          <pre>{{ task.signatures.legendaryMember }}</pre>
        </div>
      </div>
    </box>
    <box class="pb-4">
      <h3 class="mb-4">Rewards</h3>
      <p v-for="(rule, index) in task.rules" :key="index">
        {{ rule.title }}: <strong>{{ rule.price }} stakes</strong>
        {{ task.countedStakes }}
      </p>
      <p v-for="(reward, index) in task.stakesCount" :key="index">
        {{ reward.title }}: <strong>{{ reward.price }} stakes</strong>
        {{ task.countedStakes }}
      </p>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';

export default {
  mixins: [taskMixin]
};
</script>
